import type { Item } from "../types";
import { ItemId } from "../types/constants";

const basePath = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

export const items: Item[] = [
  { id: ItemId.ITEM_ORIGINIUM_ORE, tier: 1 },
  { id: ItemId.ITEM_QUARTZ_SAND, tier: 1 },
  { id: ItemId.ITEM_IRON_ORE, tier: 1 },
  { id: ItemId.ITEM_COPPER_ORE, tier: 1 },
  { id: ItemId.ITEM_LIQUID_WATER, tier: 1, isLiquid: true },
  { id: ItemId.ITEM_LIQUID_ACID, tier: 1, isLiquid: true },
  { id: ItemId.ITEM_PLANT_MOSS_1, tier: 1 },
  { id: ItemId.ITEM_PLANT_MOSS_SEED_1, tier: 1 },
  { id: ItemId.ITEM_PLANT_MOSS_2, tier: 1 },
  { id: ItemId.ITEM_PLANT_MOSS_SEED_2, tier: 1 },
  { id: ItemId.ITEM_PLANT_MOSS_3, tier: 1 },
  { id: ItemId.ITEM_PLANT_MOSS_SEED_3, tier: 1 },
  { id: ItemId.ITEM_PLANT_BBFLOWER_1, tier: 1 },
  { id: ItemId.ITEM_PLANT_BBFLOWER_SEED_1, tier: 1 },
  { id: ItemId.ITEM_PLANT_GRASS_1, tier: 1 },
  { id: ItemId.ITEM_PLANT_GRASS_SEED_1, tier: 1 },
  { id: ItemId.ITEM_PLANT_GRASS_2, tier: 1 },
  { id: ItemId.ITEM_PLANT_GRASS_SEED_2, tier: 1 },
  { id: ItemId.ITEM_PLANT_SP_1, tier: 2 },
  { id: ItemId.ITEM_PLANT_SP_2, tier: 2 },
  { id: ItemId.ITEM_PLANT_SP_3, tier: 2 },
  { id: ItemId.ITEM_PLANT_SP_4, tier: 2 },
  { id: ItemId.ITEM_PLANT_SP_SEED_1, tier: 2 },
  { id: ItemId.ITEM_PLANT_SP_SEED_2, tier: 2 },
  { id: ItemId.ITEM_PLANT_SP_SEED_3, tier: 2 },
  { id: ItemId.ITEM_PLANT_SP_SEED_4, tier: 2 },
  { id: ItemId.ITEM_PLANT_TUNDRA_WOOD, tier: 1 },
  { id: ItemId.ITEM_ACTIVITY_XIRANITE_BOTTLE, tier: 3 },
  { id: ItemId.ITEM_ACTIVITY_XIRANITE_CMPT, tier: 3 },
  { id: ItemId.ITEM_CARBON_MTL, tier: 2 },
  { id: ItemId.ITEM_ACTIVITY_XIRANITE_ENR_BOTTLE, tier: 4 },
  { id: ItemId.ITEM_CRYSTAL_SHELL, tier: 2 },
  { id: ItemId.ITEM_FBOTTLE_XIRANENR_GRASS_2, tier: 4, asTarget: false },
  { id: ItemId.ITEM_ACTIVITY_XIRANITE_ENR_CMPT, tier: 4 },
  { id: ItemId.ITEM_QUARTZ_GLASS, tier: 2 },
  { id: ItemId.ITEM_ACTIVITY_XIRANITE_ENR_TOOL, tier: 4 },
  { id: ItemId.ITEM_IRON_NUGGET, tier: 2 },
  { id: ItemId.ITEM_ACTIVITY_XIRANITE_HULU, tier: 4 },
  { id: ItemId.ITEM_COPPER_NUGGET, tier: 2 },
  { id: ItemId.ITEM_ACTIVITY_XIRANITE_ENR_HULU, tier: 5 },
  { id: ItemId.ITEM_ORIGINIUM_POWDER, tier: 2 },
  { id: ItemId.ITEM_CARBON_POWDER, tier: 2 },
  { id: ItemId.ITEM_CRYSTAL_POWDER, tier: 2 },
  { id: ItemId.ITEM_QUARTZ_POWDER, tier: 2 },
  { id: ItemId.ITEM_IRON_POWDER, tier: 2 },
  { id: ItemId.ITEM_COPPER_POWDER, tier: 2 },
  { id: ItemId.ITEM_PLANT_MOSS_POWDER_3, tier: 2 },
  { id: ItemId.ITEM_PLANT_BBFLOWER_POWDER_1, tier: 2 },
  { id: ItemId.ITEM_ORIGINIUM_ENR_POWDER, tier: 3 },
  { id: ItemId.ITEM_CARBON_ENR_POWDER, tier: 3 },
  { id: ItemId.ITEM_CRYSTAL_ENR_POWDER, tier: 3 },
  { id: ItemId.ITEM_QUARTZ_ENR_POWDER, tier: 3 },
  { id: ItemId.ITEM_IRON_ENR_POWDER, tier: 3 },
  { id: ItemId.ITEM_PLANT_MOSS_ENR_POWDER_1, tier: 3 },
  { id: ItemId.ITEM_PLANT_MOSS_ENR_POWDER_2, tier: 3 },
  { id: ItemId.ITEM_CARBON_ENR, tier: 3 },
  { id: ItemId.ITEM_CRYSTAL_ENR, tier: 3 },
  { id: ItemId.ITEM_QUARTZ_ENR, tier: 3 },
  { id: ItemId.ITEM_IRON_ENR, tier: 3 },
  { id: ItemId.ITEM_MUCK_XIRANITE_1, tier: 3 },
  { id: ItemId.ITEM_COPPER_ENR, tier: 3 },
  { id: ItemId.ITEM_FBOTTLE_GLASS_ACID, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASS_COPPER, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASS_COPPER_ENR, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASS_GRASS_1, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASS_GRASS_2, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASS_SEWAGE, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASS_WATER, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASS_XIRANITE, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASS_XIRANITE_ENR, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASS_XIRANITE_LOWPOLY, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASS_XIRANITE_POLY, tier: 2, asTarget: false },
  { id: ItemId.ITEM_GLASS_BOTTLE, tier: 2 },
  { id: ItemId.ITEM_FBOTTLE_GLASSENR_ACID, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASSENR_COPPER, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASSENR_COPPER_ENR, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASSENR_GRASS_1, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASSENR_GRASS_2, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASSENR_SEWAGE, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASSENR_WATER, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASSENR_XIRANITE, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_GLASSENR_XIRANITE_ENR, tier: 3, asTarget: false },
  {
    id: ItemId.ITEM_FBOTTLE_GLASSENR_XIRANITE_LOWPOLY,
    tier: 3,
    asTarget: false,
  },
  { id: ItemId.ITEM_FBOTTLE_GLASSENR_XIRANITE_POLY, tier: 3, asTarget: false },
  { id: ItemId.ITEM_GLASS_ENR_BOTTLE, tier: 3 },
  { id: ItemId.ITEM_FBOTTLE_IRON_ACID, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRON_COPPER, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRON_COPPER_ENR, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRON_GRASS_1, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRON_GRASS_2, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRON_SEWAGE, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRON_WATER, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRON_XIRANITE, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRON_XIRANITE_ENR, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRON_XIRANITE_LOWPOLY, tier: 2, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRON_XIRANITE_POLY, tier: 2, asTarget: false },
  { id: ItemId.ITEM_IRON_BOTTLE, tier: 2 },
  { id: ItemId.ITEM_FBOTTLE_IRONENR_ACID, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRONENR_COPPER, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRONENR_COPPER_ENR, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRONENR_GRASS_1, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRONENR_GRASS_2, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRONENR_SEWAGE, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRONENR_WATER, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRONENR_XIRANITE, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_IRONENR_XIRANITE_ENR, tier: 3, asTarget: false },
  {
    id: ItemId.ITEM_FBOTTLE_IRONENR_XIRANITE_LOWPOLY,
    tier: 3,
    asTarget: false,
  },
  { id: ItemId.ITEM_FBOTTLE_IRONENR_XIRANITE_POLY, tier: 3, asTarget: false },
  { id: ItemId.ITEM_IRON_ENR_BOTTLE, tier: 3 },
  { id: ItemId.ITEM_COPPER_BOTTLE, tier: 3 },
  { id: ItemId.ITEM_FBOTTLE_COPPER_ACID, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPER_COPPER, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPER_COPPER_ENR, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPER_GRASS_1, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPER_GRASS_2, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPER_SEWAGE, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPER_WATER, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPER_XIRANITE, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPER_XIRANITE_ENR, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPER_XIRANITE_LOWPOLY, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPER_XIRANITE_POLY, tier: 3, asTarget: false },
  { id: ItemId.ITEM_COPPER_ENR_BOTTLE, tier: 3 },
  { id: ItemId.ITEM_FBOTTLE_COPPERENR_ACID, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPERENR_COPPER, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPERENR_COPPER_ENR, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPERENR_GRASS_1, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPERENR_GRASS_2, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPERENR_SEWAGE, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPERENR_WATER, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPERENR_XIRANITE, tier: 3, asTarget: false },
  { id: ItemId.ITEM_FBOTTLE_COPPERENR_XIRANITE_ENR, tier: 3, asTarget: false },
  {
    id: ItemId.ITEM_FBOTTLE_COPPERENR_XIRANITE_LOWPOLY,
    tier: 3,
    asTarget: false,
  },
  { id: ItemId.ITEM_FBOTTLE_COPPERENR_XIRANITE_POLY, tier: 3, asTarget: false },
  { id: ItemId.ITEM_XIRANITE_POWDER, tier: 2 },
  { id: ItemId.ITEM_XIRANITE_ENR_POWDER, tier: 3 },
  { id: ItemId.ITEM_XIRANITE_POLY, tier: 3 },
  { id: ItemId.ITEM_PROC_BATTERY_1, tier: 3 },
  { id: ItemId.ITEM_PROC_BATTERY_2, tier: 3 },
  { id: ItemId.ITEM_PROC_BATTERY_3, tier: 4 },
  { id: ItemId.ITEM_PROC_BATTERY_4, tier: 4 },
  { id: ItemId.ITEM_PROC_BATTERY_5, tier: 4 },
  { id: ItemId.ITEM_GLASS_CMPT, tier: 2 },
  { id: ItemId.ITEM_GLASS_ENR_CMPT, tier: 3 },
  { id: ItemId.ITEM_IRON_CMPT, tier: 2 },
  { id: ItemId.ITEM_IRON_ENR_CMPT, tier: 3 },
  { id: ItemId.ITEM_COPPER_CMPT, tier: 3 },
  { id: ItemId.ITEM_COPPER_ENR_CMPT, tier: 4 },
  { id: ItemId.ITEM_EQUIP_SCRIPT_1, tier: 2 },
  { id: ItemId.ITEM_EQUIP_SCRIPT_2, tier: 2 },
  { id: ItemId.ITEM_EQUIP_SCRIPT_3, tier: 3 },
  { id: ItemId.ITEM_EQUIP_SCRIPT_4, tier: 4 },
  { id: ItemId.ITEM_EQUIP_SCRIPT_4_1, tier: 4 },
  { id: ItemId.ITEM_EQUIP_SCRIPT_4_2, tier: 4 },
  { id: ItemId.ITEM_LIQUID_SEWAGE, tier: 3, isLiquid: true },
  { id: ItemId.ITEM_LIQUID_PLANT_GRASS_1, tier: 3, isLiquid: true },
  { id: ItemId.ITEM_LIQUID_PLANT_GRASS_2, tier: 3, isLiquid: true },
  { id: ItemId.ITEM_LIQUID_XIRANITE, tier: 3, isLiquid: true },
  { id: ItemId.ITEM_LIQUID_XIRANITE_ENR, tier: 3, isLiquid: true },
  { id: ItemId.ITEM_LIQUID_XIRANITE_POLY, tier: 3, isLiquid: true },
  { id: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, tier: 3, isLiquid: true },
  { id: ItemId.ITEM_LIQUID_COPPER, tier: 3, isLiquid: true },
  { id: ItemId.ITEM_LIQUID_COPPER_ENR, tier: 3, isLiquid: true },
  { id: ItemId.ITEM_BOTTLED_FOOD_1, tier: 3 },
  { id: ItemId.ITEM_BOTTLED_FOOD_2, tier: 3 },
  { id: ItemId.ITEM_BOTTLED_FOOD_3, tier: 4 },
  { id: ItemId.ITEM_BOTTLED_FOOD_4, tier: 3 },
  { id: ItemId.ITEM_BOTTLED_FOOD_5, tier: 4 },
  { id: ItemId.ITEM_BOTTLED_REC_HP_1, tier: 3 },
  { id: ItemId.ITEM_BOTTLED_REC_HP_2, tier: 3 },
  { id: ItemId.ITEM_BOTTLED_REC_HP_3, tier: 4 },
  { id: ItemId.ITEM_BOTTLED_REC_HP_4, tier: 3 },
  { id: ItemId.ITEM_BOTTLED_REC_HP_5, tier: 4 },
  { id: ItemId.ITEM_PLANT_MOSS_POWDER_1, tier: 2 },
  { id: ItemId.ITEM_PLANT_MOSS_POWDER_2, tier: 2 },
  { id: ItemId.ITEM_PLANT_GRASS_POWDER_1, tier: 2 },
  { id: ItemId.ITEM_PLANT_GRASS_POWDER_2, tier: 2 },
  { id: ItemId.ITEM_PROC_BOMB_1, tier: 3 },
  { id: ItemId.ITEM_MUCK_FECES_1, tier: 1 },
];

items.forEach((item) => {
  item.iconUrl = `${basePath}/images/items/${item.id}.png`;
});
